import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, FilterProvider, DataCacheProvider } from './hooks';
import { Layout, ProtectedRoute } from './components';
import { Login, Dashboard, Analytics, Events, EventDetail, Sessions, Users, Devices, Corrupted, Deduplication, Conflicts, DeviceLinkConflicts, AccountsOverview, AccountsList, AccountDetail, GrowthCharts, FeatureAnalytics, PlatformAnalytics, DesktopAnalytics, EducationInquiries, EducationAnalytics, EmailMarketing, CommerceAnalytics, CheckoutFunnel, MonthlyRevenue, AbandonedCheckout, WebAnalytics } from './pages';
import './App.css';

/**
 * BYOK Admin Dashboard
 * 
 * Internal admin tools for BYOK backend systems.
 * 
 * Current modules:
 * - Sync Events: Device-server sync debugging and monitoring
 * - User Accounts: Subscription, billing, and account management
 * - Feature Analytics: Product usage monitoring and user engagement
 */

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Public route */}
          <Route path="/login" element={<Login />} />

          {/* Protected routes with layout */}
          <Route
            element={
              <ProtectedRoute>
                <DataCacheProvider>
                  <FilterProvider>
                    <Layout />
                  </FilterProvider>
                </DataCacheProvider>
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/:eventId" element={<EventDetail />} />
            <Route path="/sessions" element={<Sessions />} />
            <Route path="/users" element={<Users />} />
            <Route path="/devices" element={<Devices />} />
            <Route path="/corrupted" element={<Corrupted />} />
            <Route path="/deduplication" element={<Deduplication />} />
            <Route path="/conflicts" element={<Conflicts />} />
            <Route path="/device-link-conflicts" element={<DeviceLinkConflicts />} />
            <Route path="/accounts/overview" element={<AccountsOverview />} />
            <Route path="/accounts/growth" element={<GrowthCharts />} />
            <Route path="/accounts" element={<AccountsList />} />
            <Route path="/accounts/:userId" element={<AccountDetail />} />
            <Route path="/features" element={<FeatureAnalytics />} />
            <Route path="/platforms" element={<PlatformAnalytics />} />
            <Route path="/desktop" element={<DesktopAnalytics />} />
            <Route path="/education/inquiries" element={<EducationInquiries />} />
            <Route path="/education/analytics" element={<EducationAnalytics />} />
            <Route path="/email-marketing" element={<EmailMarketing />} />
            <Route path="/commerce" element={<CommerceAnalytics />} />
            <Route path="/funnel" element={<CheckoutFunnel />} />
            <Route path="/revenue" element={<MonthlyRevenue />} />
            <Route path="/abandoned-checkout" element={<AbandonedCheckout />} />
            <Route path="/web-analytics" element={<WebAnalytics />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
